import React, { Component } from 'react'
import { Checkbox, Divider, Table, Header } from 'semantic-ui-react'
import _ from "lodash";
import InputEditor from "./InputEditor"

export default class PacksEditor extends Component {

    constructor(props) {
        super(props);

        this.state = {
            value: {
                packs: _.chain(props).get("value.packs").map(a => ({
                    ...a,
                    enabled: true
                })).unionBy(_.chain(props).get("values.packs").flatten().value(), "packName").value(),
                sizes: _.chain(props).get("values.sizes").flatten().map(size => ({
                    ...size,
                    NrfSize: _.get(size, "sizeNo"),
                    NrfSizeName: _.get(size, "sizeShortDesc")
                })).value()
            },
            focused: "0-0"
        };

        _.bindAll(this, "onPackChange", "onTotalChange", "focusRef", "afterGuiAttached")
    }

    afterGuiAttached() {
        const firstKey = _.get(this, "props.charPress");
        this.setState(prev => ({
            value: {
                ...prev.value,
                packs: _.map(_.get(prev, "value.packs"), (p, i) => _.eq(i, 0) && _.toNumber(firstKey) > 0 ? {
                    ...p,
                    noOfPacks: _.toNumber(firstKey),
                    enabled: true
                } : p)
            }
        }));

        this.focusRef("1-0");
    }

    getValue() {
        const getNum = _.flow([_.get, _.toNumber]);
        const packs = _.chain(this).get("state.value.packs").filter({ enabled: true }).map(p => _.omit(p, "enabled"))
            .map(pack => ({...pack, totalQty: _.chain(pack)
                    .get("sizeScaleQtys")
                    .map(ssq => getNum(ssq, "scaleQty") * getNum(pack, "noOfPacks"))
                    .reduce((a, b) => a + b, 0).value()}))
            .value();
        const sizes = _.chain(packs).map(pack => {
            return _.chain(pack).get("sizeScaleQtys")
                .map(ssq => ({
                    ..._.chain(this).get("props.value.sizes").find(s => RegExp(`^${ssq.sizeNo}$`).test(s.NrfSize)).value(),
                    ..._.chain(this).get("state.value.sizes").find(s => RegExp(`^${ssq.sizeNo}$`).test(s.sizeNo)).value(),
                    ...ssq,
                    Quantity: getNum(ssq, "scaleQty") * getNum(pack, "noOfPacks"),
                })).value()
        }).flatten()
            .map(s => _.omit(s, ["sizeNo", "qty", "scaleQty", "sizeDesc", "sizeShortDesc"]))
            .groupBy("NrfSize").toPairs()
            .map(s => _.reduce(s[1], (a, b) => ({
                ...b,
                Quantity: getNum(a, "Quantity") + getNum(b, "Quantity")
            })))
            .value();

        return {
            packs: packs,
            sizes: sizes
        }
    }

    isPopup() {
        return true;
    }

    onPackChange(evt, { packid, checked }) {
        this.setState(prev => ({
                value: {
                    ...prev.value,
                    packs: _.chain(prev).get("value.packs")
                        .map(_.cond([
                            [_.conforms({ packName: a => _.eq(a, packid), noOfPacks: q => _.toNumber(q) > 0 }), p => ({
                                ...p,
                                enabled: checked
                            })],
                            [_.stubTrue, _.identity]
                        ])).value()
                }
            })
        )
    }

    onTotalChange(id, scaleSizeTotal, type) {
        return (evt) => {
            let { value } = evt.target;
            const noOfPacks = type === "unit" ? Math.round(_.toNumber(value) / scaleSizeTotal) : _.toNumber(value);
            const totalQty = type === "unit" ? _.toNumber(value) : Math.round(_.toNumber(value) * scaleSizeTotal);
            this.setState(prev => ({
                    value: {
                        ...prev.value,
                        packs: _.chain(prev).get("value.packs")
                            .map(_.cond([
                                [_.matches({ packName: id }), p => ({ ...p, noOfPacks: noOfPacks, totalQty: totalQty, enabled: _.toNumber(value) > 0 })],
                                [_.stubTrue, _.identity]
                            ])).value()
                    }
                })
            )
        }
    }

    focusRef(ref) {
        const input = _.defaultTo(_.get(this, `refs.${ref}.input`), _.get(this, `refs.${ref}.inputRef`, { focus: _.noop }));
        input.focus();
        if (typeof input.selectionStart == "number") {
            input.selectionStart = input.selectionEnd = input.value.length;
        }
    }

    mainKeyDown(evt) {
        /*if (_.includes([37, 38, 39, 40], evt.keyCode)) {
          evt.preventDefault();
          evt.stopPropagation();
        }*/
    }

    handleOnKeyUp(ref) {
        return evt => {
            if (_.includes([37, 38, 39, 40], evt.keyCode)) {
                const [c, r] = _.chain(ref).split("-").map(_.toNumber).value();
                const totalPacks = _.get(this, "state.value.packs.length");
                const target = evt.target;

                if (_.isNumber(target.selectionStart)) {
                    _.cond([
                        [_.matches({ keyCode: 38 }), () => this.focusRef(`${c}-${_.clamp(r - 1, 0, totalPacks - 1)}`)],
                        [_.matches({ keyCode: 40 }), () => this.focusRef(`${c}-${_.clamp(r + 1, 0, totalPacks - 1)}`)]
                    ])(evt);
                } else {
                    _.cond([
                        [_.matches({ keyCode: 37 }), () => this.focusRef(`${_.clamp(c - 1, 0, 1)}-${r}`)],
                        [_.matches({ keyCode: 38 }), () => this.focusRef(`${c}-${_.clamp(r - 1, 0, totalPacks - 1)}`)],
                        [_.matches({ keyCode: 39 }), () => this.focusRef(`${_.clamp(c + 1, 0, 1)}-${r}`)],
                        [_.matches({ keyCode: 40 }), () => this.focusRef(`${c}-${_.clamp(r + 1, 0, totalPacks - 1)}`)]
                    ])(evt);
                }
            }
        }
    }

    render() {
        const value = _.get(this, "state.value");
        return (
            <div style={{
                padding: "10px",
                maxHeight: "60vh",
                overflowY: "auto"
            }} onKeyDown={this.mainKeyDown}>
                <h3>{_.get(value, "name")}</h3>
                {
                    <Table basic="very" celled collapsing>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Pack</Table.HeaderCell>
                                <Table.HeaderCell style={{ width: "100px" }}>Pack Quantity</Table.HeaderCell>
                                <Table.HeaderCell style={{ width: "100px" }}>Unit Quantity</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {
                                _.chain(value).get("packs")
                                    .map(({ enabled, packName: id, packName: name, noOfPacks, totalQty, sizeScaleQtys }, i) =>
                                        {
                                            const scaleSizeTotal = _.chain(sizeScaleQtys).map("scaleQty").reduce((a, b) => a+b).value();
                                            return <Table.Row key={id}>
                                                        <Table.Cell>
                                                            <Header>
                                                                <Header.Content>
                                                                    <Checkbox ref={`0-${i}`} tabIndex={0}
                                                                            onChange={this.onPackChange}
                                                                            checked={enabled || false}
                                                                            label={name} packid={id}
                                                                            onKeyUp={this.handleOnKeyUp(`0-${i}`)}
                                                                    />
                                                                    <Header.Subheader>{_.chain(sizeScaleQtys).map("scaleQty").reduce((a, b) => `${a}-${b}`).value()}</Header.Subheader>
                                                                </Header.Content>
                                                            </Header>
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            <InputEditor isControlledInput={true} ref={`1-${i}`} onChange={this.onTotalChange(id, scaleSizeTotal, "qty")}
                                                                        packid={id}
                                                                        value={noOfPacks} label="qty" size="small"
                                                                        onKeyUp={this.handleOnKeyUp(`1-${i}`)} fluid
                                                                        charRegex={/^\d+$/}
                                                                        handleInput={e => {
                                                                            if (!_.includes([8, 17, 37, 39], e.keyCode) && /^[^\d]+$/.test(e.key) && !e.ctrlKey) {
                                                                                e.preventDefault();
                                                                            }
                                                                        }}
                                                            />
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            <InputEditor isControlledInput={true} ref={`1-${i}`} onChange={this.onTotalChange(id, scaleSizeTotal, "unit")}
                                                                        packid={id}
                                                                        value={totalQty} label="unit" size="small"
                                                                        onKeyUp={this.handleOnKeyUp(`1-${i}`)} fluid
                                                                        charRegex={/^\d+$/}
                                                                        handleInput={e => {
                                                                            if (!_.includes([8, 17, 37, 39], e.keyCode) && /^[^\d]+$/.test(e.key) && !e.ctrlKey) {
                                                                                e.preventDefault();
                                                                            }
                                                                        }}
                                                            />
                                                        </Table.Cell>
                                                    </Table.Row>
                                        }
                                    ).value()
                            }
                        </Table.Body>
                    </Table>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./components/product-detail/PacksEditor.js